import Axios from 'axios';
import { DelfarApiEntity } from './delfarApiEntity.enum';
import { defaultRequestInterceptor } from './defaultRequestInterceptor';

// constants
export const delfarApiUrl = process.env.REACT_APP_DELFAR_API_URL;

// APIs axios instances (interceptors below)
export const sessionsApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.SESSIONS}`,
});
export const filesApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.FILES}`,
});
export const ordersApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.ORDERS}`,
});
export const searchApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.SEARCH}`,
});
export const healthProvidersApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.HEALTH_PROVIDERS}`,
});
export const qrsApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.QRS}`,
});
export const referralsApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.REFERRALS}`,
});
export const pharmaciesApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.PHARMACIES}`,
});

export const customerChatsApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.CUSTOMER_CHATS}`,
});
export const settlementsApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.SETTLEMENTS}`,
});

export const shippingApi = Axios.create({
    baseURL: `${delfarApiUrl}/${DelfarApiEntity.SHIPPING}`,
});

// Set default request interceptor for all apis (auth & appcheck headers)
[
    sessionsApi,
    filesApi,
    ordersApi,
    searchApi,
    healthProvidersApi,
    qrsApi,
    referralsApi,
    pharmaciesApi,
    customerChatsApi,
    settlementsApi,
    shippingApi,
].forEach((api) => api.interceptors.request.use(defaultRequestInterceptor));
